import { ApiTypes, CountryIsoCode, CurrencyIsoCode, PaymentDetailsLegalEntityType } from 'shared/data/webApp/v2';

export interface ContactQueryData {
    id?: string;
    name?: string;
}

export interface EditCounterpartyPaymentDetailsPopupContentProps
    extends Pick<UseInitialFormValuesParams, 'contact' | 'paymentDetails' | 'paymentDetailsId'> {
    contactQueryData?: ContactQueryData;
    /**
     * Read only fields. One use case: used for editing payment details from request form where we
     * want to add new PDs for a bill with a specific currency. We force user to use that currency.
     */
    fixedPaymentDetails?: UseInitialFormValuesParams['fixedFormValues'];
    onPaymentDetailsChanged: (paymentDetails?: ApiTypes['ApiAmaxPayPaymentDetailsCamelCased']) => void;
}

export interface UseInitialFormValuesParams {
    contact?: ApiTypes['ApiIntegrationsXeroPaymentDetailsCounterpartyCamelCased'] | null;
    paymentDetailsId?: string | null;
    paymentDetails?: ApiTypes['ApiAmaxPayPaymentDetailsCamelCased'][];
    isConfirmationOfPayeeOnly: boolean;
    fixedFormValues?: Partial<FormValues>;
}

export type FormValues = Omit<
    ApiTypes['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'],
    'legalEntity'
> & {
    isDefault: boolean;
    payeeBankCountry: CountryIsoCode;
    payerBankCountry: CountryIsoCode;
    currencyCode: CurrencyIsoCode;
    paymentMethod: string;
    legalEntity: Omit<
        ApiTypes['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased']['legalEntity'],
        'legalEntityType'
    > & {
        legalEntityType: PaymentDetailsLegalEntityType;
    };
    selectedBenificaryName: BenificaryNameVariant | null;
};

export enum BenificaryNameVariant {
    Provided = 'Provided',
    Suggested = 'Suggested',
}
